<template>
    <div>
         <apexchart type="bar" height="350" :options="this.chartOptions" :series="this.data"></apexchart>
    </div>
</template>

<script>
export default {
    props: [
        'data',
        'chartOptions'
    ],
    data: () => ({})
}
</script>